import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '../../translate/translate.module';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

function minTrimmedLength(min: number): ValidatorFn {
  return (control: AbstractControl) => {
    const len = String(control.value ?? '').trim().length;
    return len < min ? { minTrimmedLength: { requiredLength: min, actualLength: len } } : null;
  };
}

@Component({
  selector: 'app-name-required-modal',
  templateUrl: './name-required-modal.component.html',
  styleUrls: ['./name-required-modal.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, LoadingSpinnerComponent]
})
export class NameRequiredModalComponent {
  nameForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required, minTrimmedLength(3), Validators.maxLength(50)])
  });

  saving: boolean = false;

  constructor(private modalCtrl: ModalController) { }

  get nameControl(): FormControl {
    return this.nameForm.get('name') as FormControl;
  }

  get showMinLengthError(): boolean {
    const c = this.nameControl;
    return !!c && c.touched && c.invalid && (c.errors?.['required'] || c.errors?.['minTrimmedLength']);
  }

  get showMaxLengthError(): boolean {
    const c = this.nameControl;
    return !!c && c.touched && c.invalid && !!c.errors?.['maxlength'];
  }

  async save() {
    if (this.saving || this.nameForm.invalid) {
      this.nameControl.markAsTouched();
      return;
    }
    this.saving = true;
    const name = String(this.nameForm.value.name || '').trim();
    await this.modalCtrl.dismiss({ name });
  }

  async logout() {
    if (this.saving) return;
    await this.modalCtrl.dismiss({ logout: true });
  }
}
